<template>
    <div
        class="text-2xl text-right text-black flex"
        :class="{
            'mt-1 mr-0 md:mr-10 flex-row items-end': module_state,
            'md:flex-row md:items-center justify-end flex-col items-end': !module_state,
        }"
        data-cy="nav-welcome-user"
    >
        <a-button-group :class="{ claimsvault: !module_state }">
            <a-badge
                class="mt-1 md:mr-4 flex"
                :class="{
                    'mr-2': module_state,
                    'mr-7': !module_state,
                }"
                :count="current_upload_count"
                :offset="[0, 1]"
            >
                <div class="flex">
                    <a-button
                        :class="{
                            'button-submit-border px-2': module_state,
                            'button-submit-rounded px-2': !module_state,
                        }"
                        class="border-white"
                        @click="viewUploads"
                        data-cy="view-uploads"
                        size="small"
                    >
                        <span>
                            <div
                                :class="{
                                    'text-white hidden lg:inline-block': module_state,
                                }"
                            >
                                {{ $t('globals.navigation.main.upload_count') }}
                            </div>
                            <div
                                :class="{
                                    'lg:text-white lg:hidden inline-block flex': module_state,
                                }"
                            >
                                <UploadOutlined />
                            </div>
                        </span>
                    </a-button>
                </div>
            </a-badge>
        </a-button-group>
        <a-dropdown :placement="'bottomRight'" :trigger="['click']" data-cy="welcome-dropdown">
            <span
                class="inline-block no-underline cursor-pointer"
                :class="{ 'text-white': module_state, 'text-gray-500': !module_state }"
            >
                <span class="text-sm">
                    <template v-if="module_state">
                        <span class="hidden md:inline-block">
                            {{ $t('globals.navigation.main.welcome_back') }}
                        </span>
                        <span class="inline-block md:hidden">
                            {{ $t('globals.navigation.main.welcome_back_ex') }}
                        </span>
                    </template>

                    <template v-if="!module_state">
                        {{ $t('globals.navigation.main.welcome_back') }}
                    </template>
                    <span
                        :class="{
                            'text-white hidden md:inline-block': module_state,
                            'text-default-purple': !module_state,
                        }"
                    >
                        {{ currentName }}
                    </span>
                </span>
                <MoreOutlined class="valign" />
            </span>
            <template #overlay>
                <a-menu @click="handleUserMenu">
                    <a-menu-item key="1" v-if="showAdminLink" data-cy="nav-admin-settings">
                        {{ $t('globals.navigation.main.admin') }}
                    </a-menu-item>
                    <a-menu-item key="2" v-if="showAssociationLink" data-cy="nav-association-settings">
                        {{ $t('globals.navigation.main.association') }}
                    </a-menu-item>
                    <a-menu-item key="3" v-if="showCompanyLink" data-cy="nav-company-settings">
                        {{ $t('globals.navigation.main.company') }}
                    </a-menu-item>
                    <a-menu-item key="4" data-cy="nav-reports">
                        {{ $t('globals.navigation.main.reports') }}
                    </a-menu-item>
                    <a-menu-item key="5" data-cy="nav-user-settings">
                        {{ $t('globals.navigation.main.user_settings') }}
                    </a-menu-item>
                    <a-menu-item key="6" data-cy="nav-email-admins">
                        {{ $t('globals.navigation.main.email_admins') }}
                    </a-menu-item>
                    <a-menu-item key="7" data-cy="nav-logout">
                        {{ $t('globals.navigation.main.logout') }}
                    </a-menu-item>
                </a-menu>
            </template>
        </a-dropdown>
        <modal-email-user
            @formSubmit="onAdminEmail"
            ref="EmailUserModal"
            :email_data="email_data"
            :modal_title="$t('globals.navigation.admin.email_modal.title')"
            :modal_type="'admin'"
            @update="updateEmailData"
        />
        <modal-uploads ref="UploadsModal" :processing="processing" />
    </div>
</template>

<script>
import System from '@/models/system.js';
import User from '@/models/user.js';
import ModalEmailUser from '@/components/modals/EmailUserModal.vue';
import ModalUploads from '@/components/modals/UploadsModal.vue';
import { MoreOutlined, UploadOutlined } from '@ant-design/icons-vue';

export default {
    components: {
        ModalEmailUser,
        ModalUploads,
        MoreOutlined,
        UploadOutlined,
    },
    computed: {
        currentName() {
            return this.$store.getters['user/name'];
        },
        showCompanyLink() {
            return User.can('manage-company');
        },
        showAssociationLink() {
            return User.can('manage-association');
        },
        showAdminLink() {
            return User.can('manage-admin');
        },
    },
    props: {
        module_state: {
            type: Boolean,
            value: false,
        },
    },
    data() {
        return {
            processing: false,
            email_data: {
                subject: '',
                body: '',
            },
            current_upload_count: 0,
        };
    },
    mounted() {
        this.fetch();
    },
    methods: {
        handleUserMenu({ key }) {
            switch (key) {
                case '1':
                    this.$router
                        .push({
                            name: 'edit-admin',
                        })
                        .catch(() => {
                            // catch unsaved cancel prompt
                        });
                    break;
                case '2':
                    this.$router
                        .push({
                            name: 'edit-associations',
                            params: { id: this.$store.getters['user/currentAssociationId'] },
                        })
                        .catch(() => {
                            // catch unsaved cancel prompt
                        });
                    break;
                case '3':
                    this.$router
                        .push({
                            name: 'edit-companies',
                            params: { id: this.$store.getters['user/currentCompanyId'] },
                        })
                        .catch(() => {
                            // catch unsaved cancel prompt
                        });
                    break;
                case '4':
                    this.$router
                        .push({
                            name: 'browse-reports',
                        })
                        .catch(() => {
                            // catch unsaved cancel prompt
                        });
                    break;
                case '5':
                    this.$router
                        .push({
                            name: 'user-settings',
                        })
                        .catch(() => {
                            // catch unsaved cancel prompt
                        });
                    break;
                case '6':
                    this.email_data = {
                        subject: '',
                        body: '',
                    };
                    this.$refs.EmailUserModal.showModal();
                    break;
                case '7':
                    this.$http.get('/api/logout').then((response) => {
                        System.resetData();
                        this.$router.go('/login');
                    });
                    break;
            }
        },
        onAdminEmail(event, type) {
            let payload = {
                ...event.data,
            };

            this.$http
                .post('/api/users/email-admins', payload)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$notification.success({
                            message: response.data.message,
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVURLA03' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        updateEmailData(value) {
            this.email_data = {
                ...this.email_data,
                ...value,
            };
        },
        viewUploads() {
            this.$refs.UploadsModal.showModal();
        },
        fetch() {
            this.$http
                .get('/api/uploads/get-current')
                .then((response) => {
                    this.current_upload_count = response.data.total_count;
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVURLA05' }),
                        });
                    }
                });
        },
    },
};
</script>
